import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const HandleIcon = ({ className }) => (_jsxs("svg", Object.assign({ className: `svg-handle-icon ${className}`, height: '5.587', viewBox: '0 0 8.5 5.587', width: '8.5', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("path", { d: 'M4.731.146a.509.509,0,0,1,.71,0,.5.5,0,0,1,0,.705l-2.3,2.3a.5.5,0,0,1-.705,0L.146.851a.5.5,0,0,1,.7-.705l1.94,1.94L4.731.146Z', fill: '#333', transform: 'translate(3.292) rotate(90)' }), _jsx("path", { d: 'M4.731,3.146a.509.509,0,0,0,.71,0,.5.5,0,0,0,0-.705l-2.3-2.3a.5.5,0,0,0-.705,0L.146,2.441a.5.5,0,0,0,.7.705l1.94-1.94,1.94,1.94Z', fill: '#333', transform: 'translate(8.5) rotate(90)' })] })));
HandleIcon.propTypes = {
    className: propStr(),
};
HandleIcon.defaultProps = {
    className: '',
};
export default HandleIcon;
